var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMesaTrabajo = function SvgMesaTrabajo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171.96 172.131",
    enableBackground: "new 0 0 171.96 172.131",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 85.713,
    cy: 86.195,
    r: 85
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000068636864349865109510000007915625026649689518_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1.098,
    y: 0.099,
    clipPath: "url(#SVGID_00000068636864349865109510000007915625026649689518_)",
    fill: "#F7EBF4",
    width: 169.229,
    height: 172.192
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000068636864349865109510000007915625026649689518_)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000044871060593132489230000007891547423650626176_",
    x: 0.713,
    y: 1.195,
    width: 170,
    height: 170
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047752058954084390740000018209343884231060890_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044871060593132489230000007891547423650626176_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000047752058954084390740000018209343884231060890_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M94.555,99.114v14.344H79.369v59.246l-45.859,2.119V99.998l-12.217,13.46l3.918-13.633 c0-8.12,2.661-15.419,10.779-15.419h43.867C87.975,84.407,94.555,90.993,94.555,99.114z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D397BF",
    d: "M48.843,86.772c0,0,0.004-15.547,0.004-25.119c0-18.659,21.94-18.903,26.058-0.243l1.697,10.905h-3.516 v8.844h-5.57l0.86,5.694l-10.043,7.938L48.843,86.772z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.369,
    y: 113.458,
    fill: "#D397BF",
    width: 15.191,
    height: 59.246
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    d: "M74.658,60.391H60.047v7.873L48.843,84.407c0,0-15.088-1.028-15.088-14.204 c0,0,11.147,4.017,11.147-5.927c0-9.945,3.634-17.941,15.627-17.941C72.524,46.335,74.658,57.88,74.658,60.391z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D397BF",
    d: "M61.737,68.079c0,1.703-1.383,3.083-3.085,3.083c-1.705,0-3.085-1.38-3.085-3.083 c0-1.705,1.379-3.084,3.085-3.084C60.354,64.995,61.737,66.375,61.737,68.079z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A1C3C6",
    d: "M166.607,99.099v73.605h-51.07c0,0,9.088-46.163,0.726-55.431c-8.359-9.269,0-16.726,0-16.726 l12.724-15.259h26.162C166.607,85.288,166.607,99.099,166.607,99.099z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D397BF",
    d: "M147.874,85.288l-9.675,15.831l-4.212,6.885l-4.999-22.716l0.21-4.311h-5.577V72.13h-3.511l1.513-9.735 l0.18-1.169c4.123-18.655,26.061-18.414,26.061,0.246C147.864,71.039,147.874,85.288,147.874,85.288z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A1C3C6",
    d: "M128.988,84.937V99.09H89.097c-8.44,0-8.179-5.893-8.179-10.451c0-4.559,0-25.525,0-25.525h14.346 v16.228c0,4.282,0.827,5.595,4.554,5.595H128.988z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.756,
    y: 16.353,
    transform: "matrix(0.7072 -0.707 0.707 0.7072 -1.3562 67.5612)",
    fill: "#B5107C",
    width: 24.281,
    height: 38.13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.012,
    y: 97.481,
    transform: "matrix(0.707 -0.7072 0.7072 0.707 -64.3273 79.8016)",
    fill: "#B5107C",
    width: 24.277,
    height: 40.117
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.335,
    y: 91.141,
    transform: "matrix(0.7069 -0.7073 0.7073 0.7069 -50.8031 75.2561)",
    fill: "#E149A4",
    width: 4.148,
    height: 15.582
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.582,
    y: 10.081,
    transform: "matrix(0.7069 -0.7073 0.7073 0.7069 11.5835 63.6984)",
    fill: "#E149A4",
    width: 4.148,
    height: 15.582
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D397BF",
    d: "M95.264,63.114v-3.907l4.342-5.88c0,0-4.92-5.836-6.556-8.108c-2.448-3.401-7.075-1.248-4.455,2.994 l2.498,3.27c0,0-4.726,1.001-5.301,6l-4.877-4.88v10.51H95.264z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    d: "M148.614,85.288v25.013c0,7.269-10.415,7.393-10.415,0v-9.182c0-5.038,0-9.835,0-9.835V65.716 c0-6.294-5.577-10.78-5.577-10.78v7.495h-10.999v-0.037l0.18-1.169c4.123-18.655,26.811-18.414,26.811,0.246 C148.614,71.039,148.614,85.288,148.614,85.288L148.614,85.288z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D397BF",
    d: "M142.006,67.361c0,1.703-1.38,3.083-3.082,3.083c-1.704,0-3.086-1.38-3.086-3.083 c0-1.704,1.383-3.085,3.086-3.085C140.626,64.276,142.006,65.657,142.006,67.361z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#363636",
    points: "120.109,72.13 120.109,84.937 128.988,84.937 129.197,80.977 123.621,80.977 123.621,72.13  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F1",
    d: "M138.199,105.219v3.325c-1.034,0.886-2.153,1.367-3.34,1.367c-5.609,0-9.841-10.731-9.841-24.974h2.182 c0,13.435,4.041,22.792,7.66,22.792C135.98,107.729,137.135,106.843,138.199,105.219z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D397BF",
    d: "M56.05,117.818l-6.03,14.54H11.706c-2.698,0-5.17-1.489-6.428-3.868 c-1.258-2.384-1.098-5.263,0.415-7.488l5.132-7.544l18.076-26.193l14.737,8.076l-13.782,18.117l-2.966,4.359H56.05z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D397BF",
    d: "M58.379,122.022H49.93c-0.802,0-1.456-0.655-1.456-1.455v-1.295c0-0.799,0.654-1.454,1.456-1.454h8.449 C61.646,117.818,61.646,122.022,58.379,122.022z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "45.387,93.827 29.856,113.458 10.825,113.458 28.901,87.266  "
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMesaTrabajo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mesa-trabajo.bcfbae00.svg";
export { ForwardRef as ReactComponent };